import { useQuery } from '@apollo/client/react'
import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { PileNodeConnection } from '@src/generated/schema'
import { Pile } from '@src/graphql/Pile'
import debounce from 'lodash.debounce'
import { MultiSelect } from '@src/components/Elements/MultiSelect'
import { MultiSelectProps } from '@src/components/Elements/MultiSelect/MultiSelect'

export const noDistrict = 'noDistrict'

export const DistrictSelect: FC<Pick<MultiSelectProps, 'required'>> = (props) => {
  const { t } = useTranslation()
  const { data, loading, fetchMore, refetch } = useQuery<{ pileDistricts: PileNodeConnection }>(Pile.getPileDistricts, {
    variables: {
      first: 10,
    },
    fetchPolicy: 'network-only',
  })
  const { pileDistricts: { edges } = { edges: [] as any } } = data || {}

  const handleSearch = useCallback(
    debounce((value: string) => {
      refetch({
        first: 10,
        district_Icontains: value,
      })
    }, 100),
    [],
  )

  const handlePopupScroll = (e: any) => {
    e.persist()
    const scrollTop = e.target.scrollTop as number
    const offsetHeight = e.target.offsetHeight as number

    if (scrollTop + offsetHeight === e.target.scrollHeight) {
      fetchMore({
        variables: {
          after: data?.pileDistricts.pageInfo.endCursor,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const newEdges = fetchMoreResult.pileDistricts.edges
          const pageInfo = fetchMoreResult.pileDistricts.pageInfo

          return newEdges.length
            ? {
                pileDistricts: {
                  pageInfo,
                  __typename: prev.pileDistricts.__typename,
                  edges: [...prev.pileDistricts.edges, ...newEdges],
                },
              }
            : prev
        },
      })
    }
  }

  return (
    <MultiSelect
      {...props}
      label={t('desktop.pages.piles.filter.district')}
      options={edges.map(({ node: { district } }) => ({
        title: district || t('desktop.pages.piles.filter.withoutDistrict'),
        value: district || noDistrict,
      }))}
      name='district'
      loading={loading}
      onSearch={handleSearch}
      onPopupScroll={handlePopupScroll}
    />
  )
}
